<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content>
    <form [formGroup]="notesForm">
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Notes</mat-label>
            <textarea 
                class="notes-text"
                matInput 
                formControlName="notes" 
                rows="6"
                placeholder="Enter notes about this transaction alert..."
                maxlength="1000">
            </textarea>
            <mat-hint align="end">{{ notesForm.get('notes')?.value?.length || 0 }}/1000</mat-hint>
        </mat-form-field>

        <div class="notes-metadata" *ngIf="notesMetadata">
            <mat-icon>info</mat-icon>
            <span>{{ notesMetadata }}</span>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="isLoading">
        {{ isEditMode ? 'Cancel' : 'Close' }}
    </button>
    
    <button 
        mat-raised-button 
        *ngIf="isEditMode" 
        (click)="saveNotes()" 
        color="primary"
        [disabled]="isLoading || notesForm.invalid">
        <span *ngIf="!isLoading">Save</span>
        <span *ngIf="isLoading">Saving...</span>
    </button>
</mat-dialog-actions>
